'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities'),
    chartTypes = require('./chartTypes');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'FEATURE_USAGE_TREND',
    dataSeries = {
        TIMESTAMP: 'timestamp',
        SSID_PROFILES_WITH_FIREWALL: 'ssidProfilesWithFirewall',
        SSID_PROFILES_WITH_GUEST: 'ssidProfilesWithGuestSsid',
        SSID_PROFILES_WITH_NAT: 'ssidProfilesWithNat',
        SSID_PROFILES_WITH_SCHEDULING: 'ssidProfilesWithSsidScheduling',
        SSID_PROFILES_WITH_QOS: 'ssidProfilesWithQos'
    },
    fieldNames = {
        SSID_PROFILES_WITH_FIREWALL: 'amcNumOfSsidProfilesBeingUsedInTemplateWithFirewallEnabled',
        SSID_PROFILES_WITH_GUEST: ['amcNumOfAppliedAuthWlanProfilesWithIsguestFlagSet', 'amcNumOfSsidProfilesBeingUsedInTemplateWithGuestFlag'],
        SSID_PROFILES_WITH_NAT: 'amcNumOfSsidProfilesBeingUsedInTemplateWithNatEnabled',
        SSID_PROFILES_WITH_SCHEDULING: 'amcNumOfSsidProfilesBeingUsedInTemplateWithSsidScheduling',
        SSID_PROFILES_WITH_QOS: 'amcNumOfSsidProfilesBeingUsedInTemplateWithQosMapping'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'timeseries',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        aggregations: generateFeatureAggregatorSumQuery(dataSeries, fieldNames)
    }];

module.exports = chartTypes.trendCharts.createConfig({
    chartId: chartId,
    dataSeries: dataSeries,
    fieldNames: fieldNames,
    dataConfig: dataConfig,
    chartTemplate: chartTemplate,
    averageTask: true
});

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        granularity = data.__granularity,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false);

    var yAxisBaseUnit = '',
        yAxisRoundOff = false,
        xAxisFormatter = $u.charts.generateXaxisDaysData,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
	yAxisTrimDecimalPlaces = 2;

    var chartTemplateObj = {
        dataTableConfig: {
            duration: duration,
            granularity: granularity,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Dates'
        },
        chart: {
            zoomType: 'x,y',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                        yAxisObject.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var that = this,
                    tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}<br>{1}: {2} {3} {4}',
                    xAxisFormatter(duration, granularity, this.x),
                    that.series.name,
                    tooltipUnitObj.value,
                    tooltipUnitObj.unit,
                    'SSIDs');

            },
            valueDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data[dataSeries.TIMESTAMP],
            /*!ToDo this may be a setting for druid default time series name*/
            tickmarkPlacement: 'on',
            labels: {
                step: function() {
                    if (data.timestamp) {
                        return data.timestamp.length >=
                            GRAPHS.GLOBAL.MAX_XAXIS_LABELS ? 2 : 1;
                    }
                }(),
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function() {
                    return xAxisFormatter(duration, granularity, this.value);
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            title: {
                text: data.i18n.YAXIS_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;

                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff).value;
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            min: 0,
            maxPadding: 0.1,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: width / 400 + 1
                }
            },
            series: {
                events: {
                    legendItemClick: function() {
                        var dataUnit,
                            legendContext = this,
                            legendIndex = legendContext.index,
                            dataArray = [];

                        _.forEach(legendContext.chart.legend.allItems, function(legendItem) {
                            if (legendItem.index === legendIndex) {
                                if (!legendItem.visible) {
                                    dataArray.push(legendItem.dataMax);
                                }
                            } else {
                                if (legendItem.visible) {
                                    dataArray.push(legendItem.dataMax);
                                }
                            }
                        });

                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;

                        legendContext.yAxis.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    }
                }
            }
        },
        series: [{
            type: 'line',
            name: 'Firewall',
            data: data[dataSeries.SSID_PROFILES_WITH_FIREWALL],
            color: GRAPHS.GLOBAL.COLORS.MOJO_RED
        }, {
            type: 'line',
            name: 'Guest SSIDs',
            data: data[dataSeries.SSID_PROFILES_WITH_GUEST],
            color: GRAPHS.GLOBAL.COLORS.CHART_GREEN
        }, {
            type: 'line',
            name: 'NAT',
            data: data[dataSeries.SSID_PROFILES_WITH_NAT],
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        }, {
            type: 'line',
            name: 'Scheduling',
            data: data[dataSeries.SSID_PROFILES_WITH_SCHEDULING],
            color: GRAPHS.GLOBAL.COLORS.MOJO_PURPLE
        }, {
            type: 'line',
            name: 'QoS',
            data: data[dataSeries.SSID_PROFILES_WITH_QOS],
            color: GRAPHS.GLOBAL.COLORS.MOJO_TEAL
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}

function generateFeatureAggregatorSumQuery(dataSeriesObj, fieldNamesObj) {
    var returnArray = [];

    _.forEach(_.keys(dataSeriesObj), function(key) {
        if (key === 'SSID_PROFILES_WITH_GUEST') {
            returnArray.push({
                type: 'javascript',
                name: dataSeriesObj[key],
                fieldNames: fieldNamesObj[key],
                'fnAggregate': 'function(current, a, b) { return current + (Math.max(a, b)); }',
                'fnCombine': $d.aggregateCombineFunction,
                'fnReset': $d.aggregateResetFunction
            });
        } else if (key !== 'TIMESTAMP') {
            returnArray.push({
                'type': 'longSum',
                'name': dataSeriesObj[key],
                'fieldName': fieldNamesObj[key]
            });
        }
    });

    return returnArray;
}
